import { useQuery } from "@tanstack/react-query";
import { customFetch } from "../lib/customFetch";
import { buildUrl } from "../lib/buildUrl";

export function useGetEventsCount({ period }: { period: string }) {
  const payload = useQuery({
    queryKey: ["getEventsCount", period],
    queryFn: async () => {
      return customFetch(buildUrl(`/events/count?period=${period}`));
    },
  });

  return payload;
}
